import React from 'react'

const Category = ({name, unadjusted, adjusted}) => {

  const adjustedSalary = () => {
    if(adjusted){
      adjusted = parseFloat(adjusted).toFixed(2)
      adjusted = parseFloat(adjusted).toLocaleString('en-US')
      return adjusted
    }
    return "$"
  }
  
  const unadjustedSalary = () => {
    if(unadjusted){
      unadjusted = parseFloat(unadjusted).toFixed(2)
      unadjusted = parseFloat(unadjusted).toLocaleString('en-US')
      return unadjusted
    }
    return "$"
  }

  
  return (
    <div className="flex items-center justify-between text-gray-700 min-h-[40px]">
         <div className="w-1/3 px-[5px]">{name}</div>
         <div className="w-1/3 px-[5px] text-gray-500">{"$"+unadjustedSalary()}</div>
         <div className="w-1/3 px-[5px] text-gray-500">{"$"+adjustedSalary()}</div>
    </div>
  )
}

export default Category
